/*
 * Copyright (c) 2019. Ratespecial Interactive
 */

import {Injectable} from '@angular/core';
import {Toast} from './toast-interface';
import {ToastType} from './toast-type';

@Injectable({providedIn: 'root'})
export class ToastService {

  toasts: Toast[] = [];

  success(
    message,
    title = null,
    autohide = true,
    delay = 5000,
    hasHeader = true,
  ): void {
    this.add({title, message, type: ToastType.success, autohide, delay, hasHeader});
  }

  info(message, title = null, autohide = true, delay = 5000, hasHeader = true): void {
    this.add({title, message, type: ToastType.info, autohide, delay, hasHeader});
  }

  error(message, title = null, autohide = true, delay = 10000, hasHeader = true): void {
    this.add({title, message, type: ToastType.error, autohide, delay, hasHeader});
  }

  warning(message, title = null, autohide = true, delay = 5000, hasHeader = true): void {
    this.add({title, message, type: ToastType.warning, autohide, delay, hasHeader});
  }

  add(toast: Toast): void {
    if (toast.title === '' || toast.title === null) {
      toast.hasHeader = false;
      toast.autohide = true;
    }
    this.toasts.push(toast);
  }

  remove(toast: Toast): void {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}
